import type { FC } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { FormControlLabel, Radio, RadioGroup } from '@mui/material';
import { useFormikContext } from 'formik';

import type { FormFieldKeys } from '../constants';
import FollowUpInput from '../FollowUpInput';

interface CallHappenedInputProps {
  disabled?: boolean;
}

const CallHappenedInput: FC<CallHappenedInputProps> = ({
  disabled = false,
}) => {
  const { t } = useTranslation('followUp');
  const { values, handleChange } = useFormikContext<FormFieldKeys>();
  return (
    <FollowUpInput
      name="callHappened"
      label={t('followUpCall.didYouFollowUp')}
      disabled={disabled}
    >
      <RadioGroup
        id="callHappened"
        name="callHappened"
        value={values.callHappened}
        onChange={(event) =>
          handleChange({
            ...event,
            target: {
              ...event.target,
              name: 'callHappened',
              value: event.target.value === 'true',
            },
          })
        }
        row
      >
        <FormControlLabel control={<Radio />} label={t('Yes')} value={true} />
        <FormControlLabel control={<Radio />} label={t('No')} value={false} />
      </RadioGroup>
    </FollowUpInput>
  );
};

export default CallHappenedInput;
